<template>
  <div id="safety">
    <div class="box">
      <div class="row"></div>
      <el-row :gutter="20" class="row">
        <el-col :span="3">
          <div class="lv0Text icon">
            <i class="fas fa-unlock-alt fa-3x"></i>
          </div>
        </el-col>
        <el-col :span="18" class="col2">
          <div class="lv1Text">修改登录密码</div>
          <div class="lv3Text">建议您定期更换密码，设置安全性高的密码可以使账号更安全</div>
        </el-col>
        <el-col :span="3">
          <div class="col3">
            <el-button size="large" @click="PWDialog=true">修改</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="row">
        <el-col :span="3">
          <div class="lv0Text icon">
            <i class="fas fa-mobile-alt fa-3x"></i>
          </div>
        </el-col>
        <el-col :span="18" class="col2">
          <div class="lv1Text">修改绑定手机号</div>
          <div class="lv3Text">安全手机可以用于登录账号，重置密码或其他安全验证</div>
        </el-col>
        <el-col :span="3">
          <div class="col3">
            <router-link to="/user/bindMobile">
              <el-button size="large">更换</el-button>
            </router-link>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="row">
        <el-col :span="3">
          <div class="lv0Text icon">
            <i class="fas fa-key fa-3x"></i>
          </div>
        </el-col>
        <el-col :span="18" class="col2">
          <div class="lv1Text">设置支付密码</div>
          <div class="lv3Text">支付所购买商品或服务时使用</div>
        </el-col>
        <el-col :span="3">
          <div class="col3">
            <el-button size="large" @click="PW2Dialog=true">设置</el-button>
          </div>
        </el-col>
      </el-row>
      <div class="notice">
        <div class="title">安全服务提示</div>
        <div class="t">1.确认您登陆的是宝枫林网址，注意防范进入钓鱼网站，不要轻信各种即时通讯工具发送的商品或支付链接，谨防网购诈骗。</div>
        <div class="t">2.建议您安装杀毒软件，并定期更新操作系统等软件补丁，确保账号及交易安全。</div>
      </div>
    </div>
    <el-dialog title="修改登录密码" :visible.sync="PWDialog" width="50%">
      <div style="padding:0 150px">
        <el-form label-position="right" label-width="90px">
          <el-form-item>
            <span style="color:red">登录密码为6-20位的数字和字母组成,不能包含特殊字符</span>
          </el-form-item>
          <el-form-item label="原密码：">
              <el-input type="password" v-model="form1.old_pass" placeholder="请输入原密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码：">
            <el-input type="password" v-model="form1.new_pass" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：">
            <el-input type="password" v-model="form1.new_pass1" placeholder="请确认密码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="PWDialog=false">取消</el-button>
        <el-button type="primary" @click="submit1">更改</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改支付密码" :visible.sync="PW2Dialog" width="40%">
      <div style="margin-top:20px;width:80%;">
        <el-form label-position="right" label-width="120px">
          <el-form-item>
            <div class="lv2Text" style="font-weight:bold">已绑定手机：{{phone}}</div>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入验证码" v-model="form.code" maxlength="10">
              <el-button slot="append" :disabled="smsDis" @click="getSMS">{{text1}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="支付密码：">
            <el-input type="password" v-model="form.newPW1"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：">
            <el-input type="password" v-model="form.newPW2"></el-input>
            <span style="color:#e2211c">支付密码为六位不连续的数字</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="PW2Dialog = false">取消</el-button>
        <el-button type="primary" @click="submit2">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      smsDis: false,
      mobile: this.$cookies.get('user'),
      token: this.$cookies.get('token'),
      phone: '',
      dis: false,
      text1: '获取验证码',
      form: {},
      PW2Dialog: false,
      PWDialog: false,
      form1: {
        mobile: this.$cookies.get('user'),
        token: this.$cookies.get('token')
      }
    }
  },
  activated() {
    this.$store.state.user_location = '安全设置'
  },
  created() {
    this.initData()
  },
  methods: {
    alert_success(message) {
      this.$message({
        message: message,
        type: 'success',
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        message: message,
        type: 'error',
        offset: 200
      })
    },
    initData() {
      this.axios
        .get(this.serve + '/personal/get_bind_mobile', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token')
          }
        })
        .then(res => {
          this.phone = res.data.data
        })
    },
    getSMS() {
      this.axios
        .get(this.serve + '/personal/send_pay_pass_note', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token')
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.alert_success('验证码已发送!')
            var t = 59
            var that = this
            this.smsDis = true
            that.text1 = '60秒后重新发送'
            var tm = setInterval(() => {
              that.text1 = t + '秒后重新发送'
              t--
              if (t < 0) {
                clearInterval(tm)
                that.text1 = '获取短信'
                that.smsDis = false
              }
            }, 1000)
          } else {
            this.alert_error(res.data.msg)
          }
        })
    },
    submit1() {
      this.axios
        .get(this.serve + '/personal/change_login_password', {
          params: this.form1
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.PWDialog = false
            this.alert_success('密码更改成功!')
          } else {
            this.alert_error(res.data.msg)
          }
        })
    },
    submit2() {
      let param = new FormData()
      param.append('mobile', this.mobile)
      param.append('token', this.token)
      param.append('code', this.form.code)
      param.append('new_pay', this.form.newPW1)
      param.append('new_pay1', this.form.newPW2)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.axios
        .post(
          this.serve + '/personal/change_pay_password2',
          param,
          config
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.alert_success('支付密码已修改')
            this.PW2Dialog = false
          } else {
            this.alert_error(res.data.msg)
          }
        })
    }
  }
}
</script>
<style lang="scss">
#safety {
  .notice {
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    padding: 20px 10px;
    margin-top: 50px;
    .title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      padding-bottom: 10px;
    }
    .t {
      color: #999;
      line-height: 2em;
    }
  }
  .col3 {
    padding-top: 30px;
  }
  .col2 {
    padding-top: 23px;
    line-height: 2em;
    .lv1Text {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .icon {
    padding: 30px 0;
    text-align: center;
  }
  .row {
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
  }
  .box {
    border: 1px solid #ddd;
    background-color: #fff;
    padding: 80px 50px;
  }
}
</style>